/* eslint-disable import/no-unresolved */
/* eslint-disable jsx-a11y/label-has-associated-control */

import { useQuery, useReactiveVar } from '@apollo/client';
import { useEffect, useState } from 'react';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

import {
    selectValueVar, tenantIdVar, ruleSummaryPageSizeVar, ruleSummaryPageNumberVar,
    rulePassedVar, ruleFailedVar, ruleErrorVar,
} from 'Apollo/config';
import { GET_REGULATORS } from 'Apollo/Queries';
import './ReportModal.scss';

const ReportsModal = () => {
    const history = useHistory();
    const [report, setReport] = useState('');
    const [regulation, setRegulation] = useState('');
    const tenantId = useReactiveVar(tenantIdVar);
    const regulators = useQuery(GET_REGULATORS);

    const handleInput = () => {
        if (regulation === 'FR Y-7Q') {
            history.push(
                {
                    pathname: '/fry7q',
                    state: {
                        tenantId: parseInt(tenantId, 10),
                        regulationId: report,
                        regulation,
                    },
                },
            );
        }
        if (regulation === 'Metro2') {
            history.push(
                {
                    pathname: '/metro2',
                    state: {
                        tenantId: parseInt(tenantId, 10),
                        regulationId: report,
                        regulation,
                    },
                },
            );
        }
        if (regulation === 'FFIEC009') {
            history.push(
                {
                    pathname: '/FFIEC009',
                    state: {
                        tenantId: parseInt(tenantId, 10),
                        regulationId: report,
                        regulation,
                    },
                },
            );
        }
        if (regulation === 'FR 2052a') {
            history.push(
                {
                    pathname: '/fr2052a',
                    state: {
                        tenantId: parseInt(tenantId, 10),
                        regulationId: report,
                        regulation,
                    },
                },
            );
        }
        if (regulation === 'FR Y-9C') {
            history.push(
                {
                    pathname: '/fry9c',
                    state: {
                        tenantId: parseInt(tenantId, 10),
                        regulationId: report,
                        regulation,
                    },
                },
            );
        }
        if (regulation === 'FFIEC 031') {
            history.push(
                {
                    pathname: '/ffiec031',
                    state: {
                        tenantId: parseInt(tenantId, 10),
                        regulationId: report,
                        regulation,
                    },
                },
            );
        }
        if (regulation === 'FFIEC 041') {
            history.push(
                {
                    pathname: '/ffiec041',
                    state: {
                        tenantId: parseInt(tenantId, 10),
                        regulationId: report,
                        regulation,
                    },
                },
            );
        }
    };

    useEffect(() => {
        handleInput();
        ruleSummaryPageSizeVar(10);
        ruleSummaryPageNumberVar(1);
        rulePassedVar(false);
        ruleFailedVar(false);
        ruleErrorVar(false);
    }, [report]);

    return (
        <div className="reports-dropdown">
            <DropdownButton
                drop="down"
                variant="secondary"
                title="Select Report"
                style={{ fontSize: '15px' }}
            >
                {regulators.data && regulators.data.getRegulators.filter(reg => reg.displayName !== 'Data Reconciliation').map(rg => (
                    <Dropdown.Item
                        key={rg.regulatorId}
                        onClick={
                            () => {
                                setRegulation(rg.displayName);
                                setReport(rg.regulatorId);
                                selectValueVar(rg);
                            }
                        }
                    >
                        {rg.displayName}
                    </Dropdown.Item>
                ))}
            </DropdownButton>
        </div>
    );
};

export default ReportsModal;
